import {ComponentType, ReactNode} from 'react';

import {view} from '@sail/ui';

import {
  ActiveTopBar,
  AssistantContainer,
  StripeAssistantSubheaderDisclaimer,
} from '@stripe-internal/conversations-assistant';

import {MobileDevHeader} from './MobileDevHeader';

function MobileHeader() {
  return (
    <>
      <MobileDevHeader />
      <ActiveTopBar />
    </>
  );
}

export function MobileAssistantContainer({
  errorBoundary,
  children,
}: {
  errorBoundary?: ComponentType<{children: ReactNode}> | null;
  children: ReactNode;
}) {
  return (
    <view.div css={{height: '100vh'}}>
      <AssistantContainer
        header={<MobileHeader />}
        subheader={StripeAssistantSubheaderDisclaimer}
        errorBoundary={errorBoundary}
        footer={null}
      >
        {children}
      </AssistantContainer>
    </view.div>
  );
}
